export default {
    login: "/api/v1/login",   //登陆
    logout: "/api/v1/logout", //退出登陆
    register:'/api/v1/users', //用户注册
    verification:'/api/v1/order/verification',  //验证码
    user_changepass: '/api/v1/changePass',  //修改密码
    user_info: '/api/v1/me',   //获取用户信息

    // shopify店铺
    shop_list:'/api/v1/shop/list',
    shop_create:'/api/v1/shop',
    shop_update:'/api/v1/shop/update',
    shop_delete:'/api/v1/shop',
    //收款方式
    payment_list:'/api/v1/payment/list',
    payment_create:'/api/v1/payment',
    payment_update:'/api/v1/payment/:id',
    payment_delete:'/api/v1/payment/:id',

    search:'/api/v1/search',
    email_excel_upload:'/api/v1/email/excel-upload',

    // 批量邮件管理
    batch_email_list: '/api/v1/batch-email/list',
    batch_email_resend: '/api/v1/batch-email/resend',
    batch_email_delete: '/api/v1/batch-email',
    batch_email_batch_delete: '/api/v1/batch-email/batch-delete',

    //纠纷
    // 账号菜单
    dispute_menu:'/api/v1/dispute/menu',
    dispute_list:'/api/v1/dispute/list',
    dispute_detail:'/api/v1/dispute/detail',

    //商家操作按钮
    send_msg:'/api/v1/dispute/send/message',
    escalate:"/api/v1/dispute/escalate",
    accept_claim:"/api/v1/dispute/accept/claim",
    make_offer:'/api/v1/dispute/make/offer',
    provide_evidence:'/api/v1/dispute/provide-evidence',
    provide_supporting_info:'api/v1/dispute/provide-supporting-info',
    acknowledge_return_item:'api/v1/dispute/acknowledge-return-item',
    appeal:'api/v1/dispute/appeal',

    //预处理列表
    preprocess_list:'/api/v1/preprocess/list',
    cancel_preprocess:'/api/v1/preprocess/cancel',
    preprocess_refuse:'/api/v1/preprocess/refuse',
    preprocess_agree:'/api/v1/preprocess/agree',

    //上传文件
    upload:'/api/v1/upload',
    //下载文件
    download:'/api/v1/dispute/download',

    //上传文件到七牛云
    uploadImage:'/api/v1/uploadImage',

    //回复模板管理接口
    reply_template_stages: '/api/v1/reply-template/stages',           // 获取物流阶段
    reply_template_by_stage: '/api/v1/reply-template/by-stage',       // 按阶段分组查询
    reply_template_detail: '/api/v1/reply-template',                  // 模板详情 + /:id
    reply_template_create: '/api/v1/reply-template',                  // 创建模板
    reply_template_update: '/api/v1/reply-template',                  // 更新模板 + /:id
    reply_template_activate: '/api/v1/reply-template',                // 激活模板 + /:id/activate
    reply_template_deactivate: '/api/v1/reply-template',              // 停用模板 + /:id/deactivate
    reply_template_delete: '/api/v1/reply-template',                  // 删除模板 + /:id

    //AI识别结果管理接口
    ai_recognitions: '/api/v1/ai-recognitions',                       // 获取AI识别结果列表
    ai_recognitions_stats: '/api/v1/ai-recognitions/stats',           // 获取准确率统计
    ai_recognitions_stats_by_type: '/api/v1/ai-recognitions/stats/by-type', // 按类型获取准确率统计
    ai_recognitions_detail: '/api/v1/ai-recognitions',                // 获取识别结果详情 + /:id
    ai_recognitions_by_ticket: '/api/v1/ai-recognitions/ticket',      // 根据工单ID获取识别结果 + /:ticket_id
    ai_recognitions_update_accuracy: '/api/v1/ai-recognitions',       // 更新准确率判断 + /:id/accuracy
    ai_recognitions_export: '/api/v1/ai-recognitions/export',         // 导出识别结果 xlsx

    // ========== RBAC权限管理接口 ==========
    
    // 用户管理
    user_list: '/api/v1/user/list',                // 用户列表
    user_create: '/api/v1/user',                   // 创建用户
    user_update: '/api/v1/user',                   // 更新用户 + /:id
    user_delete: '/api/v1/user',                   // 删除用户 + /:id
    user_status: '/api/v1/user',                   // 更新用户状态 + /:id/status
    user_assign_roles: '/api/v1/user',             // 分配角色 + /:id/roles
    user_remove_roles: '/api/v1/user',             // 移除角色 + /:id/roles
    user_menus: '/api/v1/user/menus',              // 获取用户菜单（重要）
    
    // 角色管理
    role_list: '/api/v1/role/list',                // 角色列表
    role_all: '/api/v1/role/all',                  // 所有角色（不分页，用于下拉选择）
    role_detail: '/api/v1/role',                   // 角色详情 + /:id
    role_create: '/api/v1/role',                   // 创建角色
    role_update: '/api/v1/role',                   // 更新角色 + /:id
    role_delete: '/api/v1/role',                   // 删除角色 + /:id
    role_assign_permissions: '/api/v1/role',       // 分配权限 + /:id/permissions
    
    // 权限管理
    permission_list: '/api/v1/permission/list',    // 权限列表
    permission_tree: '/api/v1/permission/tree',    // 权限树
    permission_all: '/api/v1/permission/all',      // 所有权限（不分页）
    permission_create: '/api/v1/permission',       // 创建权限
    permission_update: '/api/v1/permission',       // 更新权限 + /:id
    permission_delete: '/api/v1/permission',       // 删除权限 + /:id
    
    // 菜单管理
    menu_list: '/api/v1/menu/list',                // 菜单列表
    menu_tree: '/api/v1/menu/tree',                // 菜单树
    menu_create: '/api/v1/menu',                   // 创建菜单
    menu_update: '/api/v1/menu',                   // 更新菜单 + /:id
    menu_delete: '/api/v1/menu',                   // 删除菜单 + /:id

    //刷新sync
    // sync:'api/v1/sync',

    // order_info:'/api/v1/order/info',
    // upload_file:'/api/v1/upload/file',
    // delete_file:'/api/v1/delete/file',//删除图片

}
